import { getUserByToken } from "@/api/user";
import { logOut } from "@/api/public";
import { getToken, removeToken } from "@/utils/auth";
import { resetRouter } from "@/router";

const getDefaultState = () => {
  return {
    token: getToken(),
    name: "",
    avatar: "",
    messageNumber: 0,
    introduction: "",
    roles: [],
    time: null,
    area: "",
    code: "",
    user: {}
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: state => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_MESSAGE: (state, number) => {
    state.messageNumber = number;
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_TIME: (state, date) => {
    state.time = date;
  },
  SET_AREA: (state, list) => {
    state.area = list;
  },
  SET_CODE: (state, code) => {
    state.code = code;
  },
  SET_USER: (state, list) => {
    state.user = list;
  }
};

const actions = {
  // get user info
  getUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getUserByToken()
        .then(response => {
          const { data } = response;
          if (!data) {
            reject("验证失败，请重新登录");
          }
          const { cnname } = data;
          commit("SET_NAME", cnname);
          commit("SET_USER", data);
          // const { loginName, roleCode, time } = data.auth;
          // commit("SET_ROLES", data.auth);
          // commit("SET_AVATAR", roleCode);
          // commit("SET_TIME", time);
          resolve(data.auth);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logOut(state.token)
        .then(() => {
          removeToken(); // must remove  token  first
          resetRouter();
          commit("RESET_STATE");
          commit("SET_ROLES", []);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken(); // must remove  token  first
      commit("RESET_STATE");
      resolve();
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
